import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router";

import { ApiError } from "@shared/types";
import { PartnerReferral } from "@modules/partners/types";
import { ReferralFormValues } from "@modules/partners/validations";

import { createReferralService } from "./service";
import { UseCreateReferralMutationOptions } from "./types";

export const listReferralsQueryKey = ["v1/partner_referral_admin"];

export function useCreateReferralMutation(
  options?: UseCreateReferralMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<PartnerReferral, ApiError, ReferralFormValues>({
    mutationFn: createReferralService,
    onSuccess: (referral) => {
      queryClient.invalidateQueries({
        queryKey: listReferralsQueryKey,
        refetchType: "all",
      });
      open?.({ type: "success", message: translate("v1/partner_referral_admin.success.create") });
      navigate(`/partners/referrals/edit/${referral.id}`);
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
    ...options,
  });
}
